/**
 * Card-Loader für Webtrainer-NG.
 *
 * cards.json wird zur Laufzeit von /ng/cards.json geladen.
 * Pfad ist konfigurierbar (Tests injizieren Mock-URL).
 */
import type { Card } from '$types/card';

export interface LoadOptions {
  url?: string;
  fetchImpl?: typeof fetch;
}

export async function loadCards({
  url = '/cards.json',
  fetchImpl = globalThis.fetch,
}: LoadOptions = {}): Promise<Card[]> {
  const res = await fetchImpl(url);
  if (!res.ok) throw new Error(`Failed to load cards.json: ${res.status}`);
  const data = (await res.json()) as unknown;
  if (!Array.isArray(data)) throw new Error('cards.json must be an array');
  return data as Card[];
}

export function indexById<T extends { id: string }>(items: readonly T[]): Map<string, T> {
  const m = new Map<string, T>();
  for (const it of items) m.set(it.id, it);
  return m;
}
